
import { QueryClient } from '@tanstack/react-query';

// Create a client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 5 * 60 * 1000, // 5 minutes
      staleTime: 30 * 1000, // 30 seconds
      retry: (failureCount, error: any) => {
        // Don't retry on 4xx errors
        if (error?.response?.status >= 400 && error?.response?.status < 500) {
          return false;
        }
        // Retry up to 3 times for other errors
        return failureCount < 3;
      },
      refetchOnWindowFocus: false, // Disable refetching on window focus for better performance
    },
  },
});

// Function to prefetch common queries on app start
export const prefetchCommonQueries = () => {
  // Prefetch common data needed across the app
  queryClient.prefetchQuery({
    queryKey: ['commonSettings'],
    queryFn: async () => {
      // Fetch application settings
      return { theme: 'light', features: ['detection', 'analysis'] };
    },
    gcTime: 24 * 60 * 60 * 1000, // 24 hours
  });
};
